<template>
  <section class="pageFlexBetweenWrap typeList">
    <div
      class="pageBigRadius pageCarServeShadow listItem"
      v-for="(item, index) in list"
      :key="index"
      :class="`${active === index ? 'active' : ''}`"
      @click="selItem(index)"
    >
      <KImg :src="item.src" />
      <p>{{ item.name }}</p>
      <van-icon v-if="active === index" class="icons" name="success" />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [
        {
          src: require("assets/u2.png"),
          name: "爱奇艺",
        },
        {
          src: require("assets/u2.png"),
          name: "腾讯视频",
        },
        {
          src: require("assets/u2.png"),
          name: "网易云音乐",
        },
      ],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    status: {
      type: Number,
      default: null,
    },
    canSel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: true,
      active: 0,
    };
  },
  created() {
    for (let index = 0; index < this.list.length; index++) {
      const element = this.list[index];
      const src = element.src;
      console.log(src);
      this.list[index].src = require("assets/productIcon/" + src);
    }
  },
  mounted() {},
  methods: {
    selItem(i) {
      this.active = i;
      this.$emit("selItem", i);
    },
  },
};
</script>

<style scoped lang="less">
.typeList {
  margin-bottom: -15px;
  .listItem {
    width: 31%;
    position: relative;
    margin-bottom: 15px;
    background: #fff;
    color: var(--assistantColor);
    padding: 5px 8px;
    box-sizing: border-box;
    .kimg {
      height: 32px;
    }
    p {
      font-size: 13px;
      text-align: center;
    }
    .icons {
      position: absolute;
      top: 3px;
      right: 3px;
      color: #fff;
      font-size: 10px;
      z-index: 2;
    }
  }
  .listItem:last-child:nth-child(3n + 2) {
    margin-right: calc((100% - 31%) / 2);
  }
  .active {
    color: var(--redColor);
    border-color: var(--redColor);
  }
  .active::after {
    content: "";
    border: 11px solid var(--redColor);
    border-left: 11px solid transparent;
    border-top: 11px solid transparent;
    border-bottom-right-radius: 10px;
    width: 0;
    height: 0;
    position: absolute;
    top: 2px;
    right: 1px;
    transform: rotate(-90deg);
    z-index: 1;
  }
  .active::before {
    content: "";
    position: absolute;
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
    border: 2px solid var(--redColor);
    border-radius: 10px;
    z-index: 3;
  }
}
</style>
